<div class="body-top">
    <div class="header-bottom  " [formGroup]="alertvarservice.ruleForm">
        <div class="header-titles">
            <p class=" query-title primary-text white-bg bold-text content-xl px-1">
                {{alertvarservice.titles.ruleTitles.define_rule_condition}}
            </p>
            <p class="selectable-text content-m enable-action" [ngClass]="queryValid && condition.actions.query.length != 0 ? '' : 'permission-denied' " (click)="verifyquery()">
                {{alertvarservice.titles.ruleTitles.run_tests}}
            </p>
        </div>
        <div class="query-wrapper">
            <div class="query  ">
                <div class="query editor-wrapper border-light radius-m">

                    <!-- <div class="query-top px-3"> -->
                    <!-- <p class=" query-title primary-text white-bg bold-text content-l px-1">
                        {{alertvarservice.titles.ruleTitles.define_rule_condition}}</p> -->
                    <!-- <div class="time">
                        <div class="timeframe bold-text border-light px-3 pt-3 primary-bg">
                            <p class=" subtitle light-text m-0 primary-bg px-2 content-s">TimeFrame</p>
                            <app-overlay-select fontsize="content-m lighter-text" overlaycontainer="border-none" formControlName="timeframe" [data]="alertvarservice.timeframe" >
                                    </app-overlay-select>
                        </div>
                        <p class="content-l bolder-text">+</p>
                        <div class="stepsize bold-text border-light px-3 pt-3 primary-bg">
                            <p class="subtitle light-text m-0 primary-bg px-2 content-s">StepSize</p>
                            <app-overlay-select fontsize="content-m lighter-text" overlaycontainer="border-none" formControlName="stepsize" [data]="alertvarservice.stepsize">
                            </app-overlay-select>
                        </div>
                    </div> -->
                    <!-- </div> -->


                    <div class="editor " #editorContainer>

                        <!-- <alert-query-editor [builtInquery]="query.getRawValue()" [readonly]="readonly" [alertId]="alertId"
                    (changedQuery)="conditionfromeditor($event)"> </alert-query-editor> -->
                    </div>
                </div>
                <div class="query-footer ">

                    <div class="alert-text content-s">
                        <ng-container *ngIf="!queryValid">
                            {{alertvarservice.errorTypes.query_error}}
                        </ng-container>
                    </div>

                    <p class="selectable-text content-m enable-action" (click)="verifyqueryClick()"> {{alertvarservice.titles.ruleTitles.verify_query}}</p>
                </div>

            </div>
            <div class="query-verify">
                <!-- <div class="test "> -->
                <!-- <p class="selectable-text content-m enable-action" (click)="verifyqueryClick()">Verify query</p> -->
                <!-- <p class="selectable-text content-m enable-action">|</p> -->
                <!-- <p class="selectable-text content-m enable-action" [ngClass]="queryValid && condition.actions.query.length != 0 ? '' : 'permission-denied' " (click)="verifyquery()">
                        Run test</p> -->
                <!-- <p class="selectable-text content-m enable-action" [ngClass]="queryValid ? '' : 'permission-denied' " (click)="verifyquery()"> -->
                <!-- {{alertvarservice.titles.ruleTitles.run_tests}}</p> -->
                <!-- <div *ngIf="!queryValid" class="alert-text content-s">
                        {{alertvarservice.errorTypes.query_error}}</div> -->
                <!-- </div> -->
                <!-- <div class="test pt-5"> -->
                <!-- <p class="selectable-text content-m enable-action" (click)="verifyqueryClick()">Verify query</p> -->

                <!-- <div *ngIf="alertvarservice.showError" class="alert-text content-s">
                        {{alertvarservice.errorTypes.query_error}}</div> -->
                <!-- </div> -->
                <div class="test-results p-2 " [ngClass]="[queryValid && condition.actions.query.length != 0 ? '' : 'permission-denied' , (runtest | keyvalue)?.length ? 'border-light radius-m':'']">
                    <ng-container *ngIf="(runtest | keyvalue)?.length">
                        <table>
                            <thead>
                                <tr>
                                    <!-- <th>METRICS</th>
                                    <th>VALUES</th> -->
                                    <ng-container *ngFor="let head of alertvarservice.runTestTableHeaders">
                                        <th>{{head}}</th>
                                    </ng-container>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of runtest  | keyvalue:originalOrder">
                                    <td>{{item.value.disp}}</td>
                                    <td>{{item.value.value}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-container>
                    <ng-container *ngIf="!(runtest | keyvalue).length">

                        <img src="../../../assets/alerts/empty-table.svg" [ngClass]="queryValid && condition.actions.query.length != 0 ? 'opacity' : ''">

                    </ng-container>
                    <!-- <ng-container *ngFor="let item of runtest  | keyvalue:originalOrder">
                        <div class="result-row">
                            <div class="labels">
                                <p class="primary-text content-m">{{item.value.disp}}:</p> -->
                    <!-- <p class="primary-text content-m">{{alertvarservice.titles.ruleTitles.auto_actionable_alerts}}</p> -->
                    <!-- <p class="primary-text content-m">{{alertvarservice.titles.ruleTitles.effective_noise_reduction}}</p> -->
                    <!-- </div>
                            <div class="results">
                                <p class="selectable-text content-m">{{item.value.value}}</p> -->
                    <!-- <p class="selectable-text content-m">{{testResultActionable}} {{alertsLabel}}</p>
                            <p class="selectable-text content-m">{{testResultNoise}} {{percentLabel}}</p> -->
                    <!-- </div>
                        </div>
                    </ng-container> -->
                </div>
                <!-- <ng-container *ngIf="!(runtest | keyvalue).length">
                       
                    <img src="../../../assets/alerts/empty-table.svg" >
              
            </ng-container> -->
            </div>
        </div>
    </div>
</div>
<div class="body-bottom pt-10" [ngClass]="queryValid && condition.actions.query.length != 0 ? '' : 'permission-denied' ">
    <div class="mandatory-action">
        <div class="titles">
            <p class="primary-text content-xl bold-text">{{alertvarservice.titles.ruleTitles.closure_action}}*</p>
            <ng-container *ngIf="!condition.actions.reason">
                <div *ngIf="!condition.actions.reason && condition.actions.reason != 0 " class="alert-text content-s">
                    {{alertvarservice.errorTypes.action_error}} </div>
            </ng-container>
        </div>
        <div class="action-list-1 ">
            <div class="action-list-new pl-3 ">
                <app-nested-dropdown class="" [data]="mockClosureAction" [content]="'Action'" header="Action" (SelectionChange)="getSelectedItems($event)" isSearch="true"></app-nested-dropdown>
                <ng-container *ngIf="(selectedAction | keyvalue)?.length">
                    <div class="actions p-2  pl-5">
                        <ng-container *ngFor="let item of selectedAction; index as i">
                            <span class=" tooltip-enable  px-2 content-m primary-text " [tooltip]="item.disp">{{item.disp}}</span>
                            <span class="content-m primary-text" *ngIf="i != selectedAction.length-1">{{alertvarservice.titles.ruleTitles.arrow}}</span>
                            <div *ngIf="i==3 && item.val=='9999'" class="comment-wrapper">
                                <p *ngIf="i==3 && item.val=='9999'" class="content-m bold-text primary-text">{{alertvarservice.titles.ruleTitles.comments}}</p>
                                <textarea *ngIf="i==3 && item.val=='9999'" class="input-border border-light " type="text" [(ngModel)]="actionComments" placeholder="Comments" (ngModelChange)="commentChange($event)"></textarea>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>

                <!-- <app-nested-dropdown [data]="mockClosureAction[2].value" [title]="mockClosureAction[2].value[0]['disp']"
                    header="Category" (SelectionChange)="getSelectedItems($event)" isSearch="true"></app-nested-dropdown>
                <app-nested-dropdown [data]="mockClosureAction[2].value[0].value"
                    [title]="mockClosureAction[2].value[0].value[0]['disp']" header="SubCategory"
                    (SelectionChange)="getSelectedItems($event)" isSearch="true"></app-nested-dropdown>
                <app-nested-dropdown [data]="mockClosureAction[2].value[0].value[0].value"
                    [title]="mockClosureAction[2].value[0].value[0].value[0]['disp']" header="Reason"
                    (SelectionChange)="getSelectedItems($event)" isSearch="true"></app-nested-dropdown> -->
            </div>
            <!-- <ng-container *ngIf="alertvarservice.mockClosureAction.status | keyvalue:originalOrder as action">

                <div class="action-sub-list">
                    <ng-container *ngFor="let list of action ">
                        <ng-container *ngIf="list.key !=0">
                            <ng-container *ngIf="list.value['disp']">
                                <div class="reviewlist pt-4 pr-4 pl-2">
                                    <div class="title secondary-text my-2 mr-2 px-4 pt-1 radius-xl"
                                        [ngClass]="list.key == condition.actions.action ? 'chips-active':'chips-default'"
                                        (click)="actionclick(list.key)">
                                        <p class="content-l primary-text enable-action"
                                            [ngClass]="list.value['disp']=='New'?'':''">{{list.value['disp']}}</p>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>

                <ng-container *ngIf="condition.actions.action">
                    <div class="action-bottom">
                        <div class="action-bottom-left">
                            <ng-container
                                *ngFor="let state of alertvarservice.mockClosureAction.status[condition.actions.action]?.state | keyvalue:originalOrder">
                                <p class="content-m primary-text enable-action" (click)="catClick(state.key)"
                                    [ngClass]="state.key===condition.actions.state ? 'selectable-text' : 'primary-text'">
                                    {{state.value['disp']}}</p>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="condition.actions.state != '' ">
                            <div class="action-bottom-right border-light-left pl-5">
                                <ng-container
                                    *ngFor="let cat of alertvarservice.mockClosureAction?.status[condition.actions.action]?.state[condition.actions.state]?.category | keyvalue:originalOrder">
                                    <p class="content-m primary-text enable-action" (click)="reasonClick(cat.key)"
                                        [ngClass]="cat.key===condition.actions.category ? 'selectable-text' : 'primary-text'">
                                        {{cat.value['disp']}}</p>
                                </ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="condition.actions.category != '' ">
                            <div class="action-bottom-right-2 border-light-left pl-5">
                                <ng-container
                                    *ngFor="let res of alertvarservice.mockClosureAction?.status[condition.actions.action]?.state[condition.actions.state]?.category[condition.actions.category]?.reason | keyvalue:originalOrder">
                                    <ng-container *ngIf="res.key != 9999">
                                        <p class="content-m primary-text enable-action" (click)="stateReasonClick(res.key)"
                                            [ngClass]="res.key===condition.actions.reason  ? 'selectable-text' : 'primary-text'">
                                            {{res.value['disp']}}</p>
                                    </ng-container>
                                    <ng-container *ngIf="res.key == 9999">
                                        <p class="content-m primary-text enable-action" (click)="stateReasonClick(res.key)"
                                            [ngClass]=" res.key===condition.actions.reason  ? 'selectable-text' : 'primary-text'">
                                            {{res.value['disp']}}</p>
                                    </ng-container>
                                </ng-container>
                                <div class="comments" [ngClass]="condition.actions.reason == '9999' ? '' :'hide'">
                                    <h5 class="bold-text primary-text">{{alertvarservice.titles.ruleTitles.comments}}</h5>
                                    <textarea class="input-border border-light primary-bg" type="text"
                                        formControlName="comments"></textarea>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </ng-container> -->
        </div>
    </div>
    <div class="optional-action">
        <div class="action">
            <!-- <div class="action-left  white-bg ">

            <ng-container *ngIf="alertvarservice.closureAction | keyvalue:originalOrder as action">
                <div class="action-list">
                    <ng-container *ngFor="let list of action ">
                        <ng-container *ngIf="list.value['disp']">
                            <div class="list py-4 pr-4 pl-2"
                                [ngClass]="[list.value.enable ? '':'disable-action',list.key === actionWindow ?'primary-bg selected-list':'white-bg']"
                                (click)="changeAction(list.key)">
                                <ng-container *ngIf="communications.pristine">
                                    <img class="icon-s default-icon" src="../../../assets/rule/greenTick.svg">
                                </ng-container>
                                <ng-container *ngIf="!communications.pristine">
                                    <img class="icon-s" [ngClass]="communications.valid ?'':'error-icon'"
                                        src="../../../assets/rule/greenTick.svg">
                                </ng-container>
                                <p class="content-l primary-text enable-action">{{list.value['disp']}}</p>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
        </div> -->
            <div class="action-title">
                <p class="content-xl bold-text primary-text">{{alertvarservice.titles.ruleTitles.send_communications}}</p>
                <p class="content-m primary-text">{{alertvarservice.titles.ruleTitles.optional}}</p>
            </div>

            <div class="action-right ">

                <ng-container *ngIf="actionWindow =='notification'">
                    <div class="notification-wrapper" [formGroup]="communications">
                        <div class="notification-header-wrapper">
                            <div class="notification-head">
                                <!-- <div class="notification-title"> -->
                                <!-- <p class="primary-text content-l bold-text"> Select the method to send communications.</p> -->
                                <!-- </div> -->
                            </div>
                            <div class="communication-select">
                                <ng-container *ngFor="let methods of alertvarservice.communicationMethods">
                                    <div class="methods">
                                        <input class="enable-action" type="radio" formControlName="method" [value]="methods.value">
                                        <p class="enable-action content-l" [ngClass]="method.value === methods.value ? 'selectable-text' : 'primary-text' " (click)="methodClick(methods.value)">{{methods.disp}}</p>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div class="notification-body">
                            <ng-container *ngIf="method.value === 'phone'">
                                <div class="phone-body" formGroupName="phone">
                                    <!-- <div class="country-code">
                                    <p class="content-l primary-text label">Country code</p>
                                    <input class="input-border permission-denied" type="text" placeholder="Country code" formControlName="country_code">
                                   
                                </div> -->
                                    <div class="phone-number">
                                        <p class="content-l primary-text label">{{alertvarservice.titles.ruleTitles.phone_number}}</p>
                                        <input class="input-border code-input permission-denied" type="text" placeholder="Country code" formControlName="country_code">
                                        <input class="input-border " maxlength="15" type="number" placeholder="Phone number" formControlName="number">
                                        <ng-container *ngIf="!communications.pristine">
                                            <p class="alert-text content-s">{{ alertvarservice.phoneError | oneError : number.errors }}</p>
                                        </ng-container>
                                    </div>
                                    <div class="message">
                                        <p class="content-l primary-text label">{{alertvarservice.titles.ruleTitles.message}}</p>
                                        <textarea class="input-border border-light" maxlength="250" rows="1" placeholder="Message" type="text" formControlName="message"></textarea>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="method.value === 'email'">
                                <div class="email-body" formGroupName="email">
                                    <div class="email_id">
                                        <p class="content-l primary-text label">{{alertvarservice.titles.ruleTitles.email_id}}</p>
                                        <input class="input-border" type="text" maxlength="30" placeholder="Email id" formControlName="mail_id">
                                        <ng-container *ngIf="!communications.pristine">
                                            <p class="alert-text content-s">{{ alertvarservice.emailError | oneError : mail_id.errors }}</p>
                                        </ng-container>
                                    </div>
                                    <div class="subject">
                                        <p class="content-l primary-text label">{{alertvarservice.titles.ruleTitles.subject}}</p>
                                        <input class="input-border" type="text" maxlength="75" placeholder="Subject" formControlName="subject">
                                    </div>
                                    <div class="message">
                                        <p class="content-l primary-text label">{{alertvarservice.titles.ruleTitles.mail_content}}</p>
                                        <textarea class="input-border border-light" maxlength="250" placeholder="Message" rows="1" type="text" formControlName="mail_body"></textarea>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>
</div>